import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import Collapse from '@mui/material/Collapse'
import CustomTableRow from '../../../PreAuth/components/response/CustomTableRow'
import ItemInfoTable from '../../../PreAuth/components/response/ItemInfoTable'
import { getColor } from '../../../PreAuth/components/response/ResponseDetailsComponentNew'
import { Chip } from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { useFormikContext } from 'formik'

function AccordionRow ({ row, index, openRow, setOpenRow, data }) {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue
  } = useFormikContext()

  const isOpen = openRow === index
  const adjudicationHeaders = [
    { name: 'Category' },
    { name: 'Value' },
    { name: '	Reason' }
  ]

  const handleRowClick = () => {
    setOpenRow(isOpen ? null : index)
  }

  return (
    <>
      <TableRow
        onClick={handleRowClick}
        sx={{
          cursor: 'pointer',
          backgroundColor: isOpen ? '#f0f0f0' : 'white'
        }}
      >
        <TableCell className='!whitespace-nowrap !px-2 !py-2 text-sm !text-gray-900'>
          {isOpen ? (
            <VisibilityOff fontSize='small' />
          ) : (
            <Visibility fontSize='small' />
          )}
        </TableCell>
        <TableCell className='!whitespace-nowrap !px-2 !py-2 text-sm !text-gray-900'>
          {index + 1}
        </TableCell>
        <TableCell className='!whitespace-nowrap !px-2 !py-2 text-sm !text-gray-900'>
          {row?.standard_code || '__'}
        </TableCell>
        <TableCell className='!whitespace-nowrap !px-2 !py-2 text-sm !text-gray-900'>
          {row.standard_description || '__'}
        </TableCell>
        <TableCell className='!whitespace-nowrap !px-2 !py-2 text-sm !text-gray-900'>
          SAR {row?.net?.toFixed(2) || 0}
        </TableCell>
        <TableCell className='!whitespace-nowrap !px-2 !py-2 text-sm !text-gray-900'>
          SAR {row?.benefit_value?.toFixed(2) || 0}
        </TableCell>
        <TableCell
          className={`!whitespace-nowrap !px-2 !py-2 text-sm  text-white  `}
        >
          <select
            className='
              block  rounded-md border-0 py-1.5 pr-10 z-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:!ring-primary sm:text-sm sm:leading-6'
            value={values?.items[index]?.status}
            onChange={e => {
              setFieldValue(`items[${index}].status`, e.target.value)
            }}
            id='outcome'
          >
            <option value=''>Select Status</option>
            <option value='approved'>Approved</option>
            <option value='rejected'>Rejected</option> 
          </select>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell colSpan={7} className='!p-0 '>
          <Collapse in={isOpen} timeout='auto' unmountOnExit>
            {values?.items[index]?.status === 'rejected' && (
              <Box className='w-full  p-3 '>
                <div className=' !shadow-none flex  !p-2 border !border-gray-300 rounded-md !mb-2 '>
                  <div class='eligibility_details_user_data  px-1.5 py-1.5 '>
                    <div class='data_head !text-left !mb-0'>
                      <span className='!text-gray-700  !text-[15px]'>
                        Reject Reason Code
                      </span>
                    </div>
                    <div class='data_cont !text-left'>
                      <input
                        placeholder='Enter Reject Reason Code'
                        type='text'
                        className='block rounded-md border-0 py-1.5 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:!ring-primary sm:text-sm sm:leading-6'
                        value={values?.items[index]?.reject_reason_code}
                        onChange={e => {
                          setFieldValue(
                            `items[${index}].reject_reason_code`,
                            e.target.value
                          )
                        }}
                        onBlur={handleBlur}
                        id='reject_reason_code'
                      />
                    </div>
                  </div>
                  <div class='eligibility_details_user_data  px-1.5 py-1.5 '>
                    <div class='data_head !text-left !mb-0'>
                      <span className='!text-gray-700  !text-[15px]'>
                        Reject Reason Display
                      </span>
                    </div>
                    <div class='data_cont !text-left'>
                      <input
                        placeholder='Enter Reject Reason display'
                        type='text'
                        className='block rounded-md border-0 py-1.5 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:!ring-primary sm:text-sm sm:leading-6'
                        value={values?.items[index]?.reject_reason_display}
                        onChange={e => {
                          setFieldValue(
                            `items[${index}].reject_reason_display`,
                            e.target.value
                          )
                        }}
                        onBlur={handleBlur}
                        id='reject_reason_display'
                      />
                    </div>
                  </div>
                </div>
              </Box>
            )}

            <Box className='w-full  p-3 '>
              <div className=' !shadow-none !p-2 border !border-gray-300 rounded-md !mb-2 '>
                <Typography
                  className='flex gap-3 !font-bold mb-2 !text-[18px]'
                  variant='h6'
                  sx={{ width: '50%', flexShrink: 0 }}
                >
                  Adjudication
                </Typography>
                <div className='pre_auth-detail_section_cont'>
                  <div className='super-git-table !p-0 !m-0'>
                    <table className='table-super-git !text-left !p-0 '>
                      <thead className='!p-0 !bg-gray-500'>
                        <tr
                          scope='col'
                          className='!whitespace-nowrap !py-[7px] !pl-4 !pr-3 !text-left text-sm !font-semibold text-white sm:!pl-2'
                        >
                          {adjudicationHeaders.map((el, index) => (
                            <th className='!p-2' key={'tableHeaders_' + index}>
                              {el.name}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody className='divide-y  divide-gray-200 bg-white'>
                        <CustomTableRow
                          values={[
                            {
                              name: 'Approved Quantity',
                              approved_quantity: `${
                                data?.getPreAuthTransaction?.data?.items[
                                  openRow
                                ]?.approved_currency || 'SAR'
                              } ${
                                data?.getPreAuthTransaction?.data?.items[
                                  openRow
                                ]?.approved_quantity || 0
                              }`,
                              reason:
                                data?.getPreAuthTransaction?.data?.items[
                                  openRow
                                ]?.approved_quantity || ''
                            },
                            {
                              name: 'Benefit',
                              Benifit: `${
                                data?.getPreAuthTransaction?.data?.items[
                                  openRow
                                ]?.benefit_currency || 'SAR'
                              } ${
                                data?.getPreAuthTransaction?.data?.items[
                                  openRow
                                ]?.benefit_value || 0
                              }`,
                              reason:
                                data?.getPreAuthTransaction?.data?.items[
                                  openRow
                                ]?.approved_quantity || ''
                            },
                            {
                              name: 'Discount',
                              Discount: `SAR ${data?.getPreAuthTransaction?.data?.items[openRow]?.discount_amount}`,
                              reason:
                                data?.getPreAuthTransaction?.data?.items[
                                  openRow
                                ]?.approved_quantity || ''
                            },
                            {
                              name: 'Patient Share',
                              value: `SAR ${
                                data?.getPreAuthTransaction?.data?.items[
                                  openRow
                                ]?.patient_share || 0
                              }`,
                              reason:
                                data?.getPreAuthTransaction?.data?.items[
                                  openRow
                                ]?.approved_quantity || ''
                            },
                            {
                              name: 'Submitted',
                              value: `${
                                data?.getPreAuthTransaction?.data?.items[
                                  openRow
                                ]?.submitted_currency || 'SAR'
                              } ${
                                data?.getPreAuthTransaction?.data?.items[
                                  openRow
                                ]?.submitted_quantity || 0
                              }`,
                              reason:
                                data?.getPreAuthTransaction?.data?.items[
                                  openRow
                                ]?.approved_quantity || ''
                            },
                            {
                              name: 'Tax',
                              value: `SAR ${
                                data?.getPreAuthTransaction?.data?.items[
                                  openRow
                                ]?.tax_amount || 0
                              } `,
                              reason:
                                data?.getPreAuthTransaction?.data?.items[
                                  openRow
                                ]?.approved_quantity || ''
                            }
                          ]}
                        />
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className='!shadow-none !p-2 border !border-gray-300 rounded-md !mb-0 '>
                <Typography
                  className='flex gap-3 !font-bold mb-2 !text-[18px]'
                  variant='h6'
                  sx={{ width: '50%', flexShrink: 0 }}
                >
                  Item info
                </Typography>
                <div className=' grid grid-cols-1 md:grid-cols-3 '>
                  <div>
                    {
                      <ItemInfoTable
                        values={[
                          {
                            name: 'Non Standard Code',
                            value:
                              data?.getPreAuthTransaction?.data?.items[openRow]
                                ?.non_standard_code || '__'
                          },
                          {
                            name: 'Non Standard Desc.',
                            value:
                              data?.getPreAuthTransaction?.data?.items[openRow]
                                ?.non_standard_description || '__'
                          },
                          {
                            name: 'Serviced Date/Period',
                            value: `${
                              data?.getPreAuthTransaction?.data?.items[openRow]
                                ?.service_start_date || '__'
                            } - ${
                              data?.getPreAuthTransaction?.data?.items[openRow]
                                ?.service_end_date || '__'
                            }`
                          },
                          {
                            name: 'Is Package?',
                            value:
                              data?.getPreAuthTransaction?.data?.items[openRow]
                                ?.is_package === true
                                ? 'Yes'
                                : 'No'
                          },
                          {
                            name: 'Body Site',
                            value:
                              data?.getPreAuthTransaction?.data?.items[openRow]
                                ?.body_site || '__'
                          },
                          {
                            name: 'Sub Site',
                            value:
                              data?.getPreAuthTransaction?.data?.items[openRow]
                                ?.sub_site || '__'
                          }
                        ]}
                      />
                    }
                  </div>
                  <div>
                    <ItemInfoTable
                      values={[
                        {
                          name: 'Quantity',
                          value:
                            data?.getPreAuthTransaction?.data?.items[openRow]
                              ?.quantity || '__'
                        },
                        {
                          name: 'Unit Price',
                          value: `SAR ${
                            data?.getPreAuthTransaction?.data?.items[openRow]
                              ?.unit_price || 0
                          }`
                        },
                        {
                          name: 'Discount Amount',
                          value: `SAR ${
                            data?.getPreAuthTransaction?.data?.items[openRow]
                              ?.discount_amount || 0
                          }`
                        },
                        {
                          name: 'Tax',
                          value: `SAR ${
                            data?.getPreAuthTransaction?.data?.items[openRow]
                              ?.tax_amount || 0
                          }`
                        },
                        {
                          name: 'Patient Share',
                          value: `SAR ${
                            data?.getPreAuthTransaction?.data?.items[openRow]
                              ?.patient_share || 0
                          }`
                        },
                        {
                          name: 'Payer Share',
                          value: `SAR ${
                            data?.getPreAuthTransaction?.data?.items[openRow]
                              ?.payer_share || 0
                          }`
                        },
                        {
                          name: 'Is Maternity?',
                          value:
                            data?.getPreAuthTransaction?.data?.items[openRow]
                              ?.maternity !== null &&
                            (data?.getPreAuthTransaction?.data?.items[openRow]
                              ?.maternity === true
                              ? 'Yes'
                              : 'No')
                        }
                      ]}
                    />
                  </div>
                  <div>
                    <ItemInfoTable
                      values={[
                        {
                          name: 'Factor',
                          value:
                            data?.getPreAuthTransaction?.data?.items[openRow]
                              ?.factor || 0
                        },
                        {
                          name: 'Prescribed Medication ',
                          value:
                            data?.getPreAuthTransaction?.data?.items[openRow]
                              ?.prescribed_medication || '__'
                        },
                        {
                          name: 'Pharmacist Substitute Reason ',
                          value:
                            data?.getPreAuthTransaction?.data?.items[openRow]
                              ?.medication_selection_reason || '__'
                        },
                        { name: '__' },

                        {
                          name: 'Diagnosis',
                          value:
                            data?.getPreAuthTransaction?.data?.diagnosis.map(
                              dig =>
                                data?.getPreAuthTransaction?.data?.items[
                                  openRow
                                ]?.diagnosis.length > 0
                                  ? `[ ${dig?.code} ]`
                                  : '__'
                            )
                        },
                        {
                          name: 'Care Teams',
                          value:
                            data?.getPreAuthTransaction?.data?.care_teams.map(
                              team =>
                                data?.getPreAuthTransaction?.data?.items[
                                  openRow
                                ]?.care_teams.length > 0
                                  ? `[ ${team?.name} ]`
                                  : '__'
                            )
                        }
                      ]}
                    />
                  </div>
                </div>
                <Typography
                  className='flex gap-3 !font-bold mb-2 !text-[18px]'
                  variant='h6'
                  sx={{ width: '50%', flexShrink: 0 }}
                >
                  Supporting Info
                </Typography>
                <div>
                  {data?.getPreAuthTransaction?.data?.supporting_info.map(
                    sp_info =>
                      data?.getPreAuthTransaction?.data?.items[openRow]
                        ?.supporting_info.length > 0
                        ? ` ${sp_info?.category}  , `
                        : '__'
                  )}
                </div>
              </div>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  )
}

export default function ItemsTable ({ data }) {
  const [openRow, setOpenRow] = useState(null)
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue
  } = useFormikContext()

  useEffect(() => {
    if (data?.getPreAuthTransaction?.data?.items) {
      data.getPreAuthTransaction.data.items.forEach((row, index) => {
        setFieldValue(`items[${index}].id`, row?.id || '')
        setFieldValue(`items[${index}].status`, row?.status || '')
        if (row?.status === 'rejected') {
          setFieldValue(
            `items[${index}].reject_reason_code`,
            row?.reject_reason_code || ''
          )
          setFieldValue(
            `items[${index}].reject_reason_display`,
            row?.reject_reason_display || ''
          )
        }
      })
    }
  }, [data, setFieldValue])
  return (
    <TableContainer className=' !shadow-none' component={Paper}>
      <Table>
        <TableHead className='bg-gray-500'>
          <TableRow>
            <TableCell
              scope='col'
              className='!whitespace-nowrap !py-[7px] !pl-4 !pr-3 !text-left text-sm !font-semibold text-white sm:!pl-2'
            ></TableCell>
            <TableCell
              scope='col'
              className='!whitespace-nowrap !py-[7px] !pl-4 !pr-3 !text-left text-sm !font-semibold text-white sm:!pl-2'
            >
              Sequence No.
            </TableCell>
            <TableCell
              scope='col'
              className='!whitespace-nowrap !py-[7px] !pl-4 !pr-3 !text-left text-sm !font-semibold text-white sm:!pl-2'
            >
              Standard Code
            </TableCell>
            <TableCell
              scope='col'
              className='!whitespace-nowrap !py-[7px] !pl-4 !pr-3 !text-left text-sm !font-semibold text-white sm:!pl-2'
            >
              Standard Description
            </TableCell>
            <TableCell
              scope='col'
              className='!whitespace-nowrap !py-[7px] !pl-4 !pr-3 !text-left text-sm !font-semibold text-white sm:!pl-2'
            >
              Net
            </TableCell>
            <TableCell
              scope='col'
              className='!whitespace-nowrap !py-[7px] !pl-4 !pr-3 !text-left text-sm !font-semibold text-white sm:!pl-2'
            >
              Benefit
            </TableCell>
            <TableCell
              scope='col'
              className='!whitespace-nowrap !py-[7px] !pl-4 !pr-3 !text-left text-sm !font-semibold text-white sm:!pl-2'
            >
              Status
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody className='!rounded-none !shadow-none'>
          {data?.getPreAuthTransaction?.data?.items?.map((row, index) => (
            <AccordionRow
              key={index}
              index={index}
              row={row}
              openRow={openRow}
              setOpenRow={setOpenRow}
              data={data}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
